$( document ).ready(function() {
$('.testimonial-reviews-section-main-inner').slick({  
    infinite: true, 
    arrows: true,
    slidesToShow: 1,  
    slidesToScroll: 1
});
  
$('.testimonial-blocks-slider').slick({  
    infinite: true, 
    arrows: true,
    slidesToShow: 3,  
    slidesToScroll: 3,
    responsive: [
    {
      breakpoint: 767,
      arrows: false,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]	
});        


$('.main-product__media-list').slick({  
    infinite: true, 
    arrows: false,
    dots: false,
    adaptiveHeight: true,                     
    slidesToShow: 1,
    // asNavFor: '.thumb-product-media-list',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerPadding: '80px',
          centerMode: false,
          arrows: true,
        }
      },
      {
      breakpoint: 767,
      settings: {
         arrows: true
        
      }
    },
    {
      breakpoint: 480,
      settings: {
       arrows: true
      }
    }
    ]
});
  
$('.thumb-product-media-list').slick({
  infinite: true, 
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  asNavFor: '.main-product__media-list',
  centerMode: true,
  centerPadding: '80px',
  arrows: false,
  focusOnSelect: true,
     responsive: [
      {
        breakpoint: 991,
        settings: {
           arrows: true,
           centerMode: true,
           centerPadding: '60px'
        }
      }
    ]
});
	

$('.faq-blocks .qus').click(function(){
 $(this).toggleClass('active');
 $(this).next().slideToggle(); 
}) 

 
// $('.blog-filters-tags li').click(function(){
//   console.log('fghfghfg')
//  $('.blog-filters-tags li').removeClass('active')
//  $(this).addClass('active'); 
// })   
  
// $('.faq-blocks .qus').click(function(e){
//   	e.preventDefault();
//     var $this = $(this);
  
//     if ($this.next().hasClass('show')) {
//         $this.next().removeClass('show');
//         $this.next().slideUp(350);
//     } else {
//         $this.parent().parent().find('.faq-item .ans').removeClass('show');
//         $this.parent().parent().find('.faq-item .ans').slideUp(350);
//         $this.next().toggleClass('show');
//         $this.next().slideToggle(350);
//     }
// });

  
$('.accordion-list > li > .answer').hide();
$(".accordion-list > li:first-of-type > .answer").slideDown();
  $('.accordion-list > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
  
$('.page--ingredients a.button-tell').click(function(e){
  e.preventDefault();
  $('.tell-button-popup').show();
  $('.tell-button-popup').addClass('active');
  $('body').addClass('open-popup');
});
$('.tell-button-popup .close-btn, .tell-button-content').click(function(){
  $('.tell-button-popup').hide();
  $('.tell-button-popup').removeClass('active');
  $('body').removeClass('open-popup');
});
 // $('.tell-button-content').click(function(){
 //  $('.tell-button-popup,.tell-button-content ').hide();
 //   $('.tell-button-popup').removeClass('active');
 //  $('body').removeClass('open-popup');   
 // });   
});   


$(document).ready(function(){
   $(document).on("click",".build-btn-mob",function() {
        $(".mob-build-box").addClass("active");
        if($('.mob-overlay').length < 1 ){
          $(".mob-build-box").before('<div class="mob-overlay"></div>');
        }
    });
  $(document).on("click",".mob-build-box.active .build-right-header h2",function() {
        $("body").removeClass("overflow-hidden");
        $(".mob-build-box").removeClass("active");
        $(".mob-overlay").remove();
  })
});    


$(document).ready(function(){
  if($(window).width() <= 767){
  $('.timeline-blocks').slick({  
      infinite: true, 
      arrows: false,
      slidesToShow: 3,  
      slidesToScroll: 3,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]	
    }); 
   }

   $('.ingredients-slider-wrap .main-grid-system').slick({  
      infinite: true, 
      arrows: true,
      slidesToShow: 3,  
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]	
    }); 
 
$('.flavour-images-wrap').slick({  
      infinite: true, 
      arrows: true,
      slidesToShow: 1,  
      slidesToScroll: 1,
    }); 
  
 // $(".nutrition-popup-content .size-img")
 //  .on("mouseover", function() {
 //    $(this)
 //      .children("img")
 //      .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
 //  })
 //  .on("mouseout", function() {
 //    $(this)
 //      .children("img")
 //      .css({ transform: "scale(1)" });
 //  })
 //  .on("mousemove", function(e) {
 //    $(this)
 //      .children("img")
 //      .css({
 //        "transform-origin":
 //          ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
 //          "% " +
 //          ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
 //          "%"
 //      });
 //  });
 
  
}) 
$(document).ready(function(){
  $('.icon-hamburger').click(function () {
    $('.header--mobile-center').css('margin-top','0');
    $('.header--mobile-center').css('background-color','#fff');
    $('.announcement-bar-section').css('display','none');
    //$('.menu-drawer').css('position','fixed');
    $('#menu-drawer').css('height','100% !important');
    $('#menu-drawer').css('top','unset');
  });
  $('.icon-close').click(function () {
    $('.header--mobile-center').css('margin-top','40px');
    $('.header--mobile-center').css('background-color','inherit');
    $('.announcement-bar-section').css('display','flex');
  });

      /*  update-buildbox  */

      let list_items = $('.updated-buildbox li');
      let quantity_input = list_items.find('quantity-input');
      let input_box = quantity_input.find('.quantity__input');
        input_box.each(function(){
          let that = $(this);
          let input_value =  $(this).val();
          if(input_value > 0){
             let buttons_container = that.closest('quantity-input');
             let buttons_val = buttons_container.find('.quantity__button');
                buttons_val.css("display", "flex");
                that.show();
                buttons_container.addClass('active-button');
          }
      });

    $('.updated-buildbox .quantity__button').click(function(){
       let inputValContainer =  $(this).closest('quantity-input');
       let inputValue = inputValContainer.find('.quantity__input');
       let input_count = inputValue.val();
        if(input_count == 0){
            inputValContainer.find('.quantity__button[name = "minus"]').hide();
            inputValue.hide();
            inputValContainer.removeClass('active-button');
        }else{
            inputValContainer.find('.quantity__button[name = "minus"]').css("display", "flex");
            inputValue.show();
            inputValContainer.addClass('active-button');
        }
    });


  
});


